import axios from 'axios';


const client = () =>
{
    let defaultOptions = {};
    return {
        get: (url, options = {}) => axios.get(url, { ...defaultOptions, ...options }),
        post: (url, params, options = {}) =>
        {
            defaultOptions = {};
            let formData = false;
            for (const key in params)
            {
                if (params[key] != null && typeof params[key] === 'object' && params.checkForFile == null)
                {
                    formData = true;
                }
            }

            if (formData)
            {
                defaultOptions = {
                    headers: {
                        'content-type': 'multipart/form-data',
                    },
                };

                const data = new FormData();
                for (const key in params)
                {
                    if (params[key] != null)
                    {
                        if (typeof params[key] === 'object')
                        {
                            const blob = new Blob([params[key][0].data], { type: 'text/plain' });
                            data.append(key, blob, params[key][0].name);
                        }
                        else
                        {
                            data.append(key, params[key]);
                        }
                    }
                }
                return axios.post(url, data, { ...defaultOptions, ...options });
            }
            return axios.post(url, params, { ...defaultOptions, ...options });
        },
        put: (url, data, options = {}) => axios.put(url, data, { ...defaultOptions, ...options }),
        delete: (url, options = {}) => axios.delete(url, { ...defaultOptions, ...options }),
        errorHandler: (e) => e.toString(),
    };
};

export default client();
